export const GRADING_MODE_LABELS = {

  scale_5: "Skala 2–5 (NP, ZW)",

  pass_fail: "Zaliczony / niezaliczony",

  percent: "Procenty (0–100%)",

};



export function normalizeGradingMode(mode) {

  if (mode === "pass_fail" || mode === "percent") {

    return mode;

  }

  return "scale_5";

}



function isPassFailPassed(num) {

  if (num === 1) return true;

  if (num === 0) return false;

  if (Number.isNaN(num)) return false;

  if (num >= 3) return true;

  if (num > 0 && num <= 2) return false;

  return false;

}



export function inferGradeFormat(raw, storedValue) {

  const text = raw !== null && raw !== undefined ? String(raw).trim().toUpperCase() : "";

  if (text) {

    if (["PASSED", "FAILED", "ZAL", "ZALICZONY", "NIEZALICZONY", "NZAL", "TAK", "NIE"].includes(text)) {

      return "pass_fail";

    }

    if (text.includes("%")) {

      return "percent";

    }

    if (text === "NP" || text === "ZW") {

      return "scale_5";

    }

    const parsed = parseFloat(text.replace(",", ".").replace("%", ""));

    if (!Number.isNaN(parsed) && parsed >= 6 && parsed <= 100) {

      return "percent";

    }

  }



  const num = Number(storedValue);

  if (!Number.isNaN(num)) {

    if (num === 0 || num === 1) {

      return "pass_fail";

    }

    if (num >= 6 && num <= 100) {

      return "percent";

    }

  }



  return "scale_5";

}



export function resolveRowGradeFormat(row) {
  const storedFormat = row?.grade_format != null ? String(row.grade_format).trim() : "";
  if (storedFormat) {
    return normalizeGradingMode(storedFormat);
  }

  if (row?.exam_status === "PASSED" || row?.exam_status === "FAILED") {
    return "pass_fail";
  }

  const stored = row?.grade ?? row?.final_grade;
  const num = Number(stored);
  if (row?.is_passed === true || row?.is_passed === false) {
    if (!Number.isNaN(num) && (num === 0 || num === 1 || num === 2 || num === 5)) {
      return "pass_fail";
    }
  }

  return inferGradeFormat(null, stored);
}



export function formatGradeDisplay(value, mode = "scale_5") {

  if (value === null || value === undefined || value === "") {

    return "—";

  }



  const gradingMode = normalizeGradingMode(mode);

  const num = Number(value);



  if (gradingMode === "pass_fail") {

    if (Number.isNaN(num)) {

      return String(value);

    }

    return isPassFailPassed(num) ? "Zaliczony" : "Niezaliczony";

  }



  if (gradingMode === "percent") {

    if (Number.isNaN(num)) {

      return String(value);

    }

    return `${Math.round(num)}%`;

  }



  return String(value);

}



const EXAM_STATUS_LABELS = {

  PASSED: "Zaliczony",

  FAILED: "Niezaliczony",

  ABSENT: "Nieobecny",

  EXEMPT: "Zwolniony",

};



export function resolveGradeDisplay(row, mode) {

  const gradingMode = normalizeGradingMode(mode || resolveRowGradeFormat(row));



  if (gradingMode === "pass_fail" && row?.exam_status && EXAM_STATUS_LABELS[row.exam_status]) {

    return EXAM_STATUS_LABELS[row.exam_status];

  }



  if (gradingMode === "pass_fail" && (row?.passed === "Zaliczony" || row?.passed === "Niezaliczony")) {

    return row.passed;

  }



  if (row?.grade_display) {

    return row.grade_display;

  }



  return formatGradeDisplay(row?.grade, gradingMode);

}



export function displayGrade(rowOrValue, gradingMode) {

  if (rowOrValue !== null && typeof rowOrValue === "object") {

    return resolveGradeDisplay(rowOrValue, gradingMode);

  }

  return formatGradeDisplay(rowOrValue, gradingMode);

}



export function getGradeSelectOptions(mode = "scale_5") {

  const gradingMode = normalizeGradingMode(mode);



  if (gradingMode === "pass_fail") {

    return [

      { value: "", label: "—" },

      { value: "PASSED", label: "Zaliczony" },

      { value: "FAILED", label: "Niezaliczony" },

    ];

  }



  if (gradingMode === "percent") {

    return null;

  }



  return [

    { value: "", label: "—" },

    { value: "2.0", label: "2.0" },

    { value: "3.0", label: "3.0" },

    { value: "3.5", label: "3.5" },

    { value: "4.0", label: "4.0" },

    { value: "4.5", label: "4.5" },

    { value: "5.0", label: "5.0" },

    { value: "ZW", label: "ZW" },

    { value: "NP", label: "NP" },

  ];

}



export function gradeValueToEditString(value, mode = "scale_5") {

  const gradingMode = normalizeGradingMode(mode);

  if (value === null || value === undefined || value === "") {

    return "";

  }



  if (gradingMode === "pass_fail") {

    const num = Number(value);

    if (Number.isNaN(num)) {

      return "";

    }

    return isPassFailPassed(num) ? "PASSED" : "FAILED";

  }



  if (gradingMode === "percent") {
    return String(Math.round(Number(value)));
  }

  const text = String(value).trim().toUpperCase();
  if (text === "NP" || text === "ZW") {
    return text;
  }

  const num = Number(String(value).replace(",", "."));
  if (!Number.isNaN(num)) {
    return num.toFixed(1);
  }

  return String(value);
}

/** Format + wartość do edycji (select / input) z wiersza oceny. */
export function rowGradeToEditState(row) {
  const format = resolveRowGradeFormat(row);
  let value = gradeValueToEditString(row?.grade ?? row?.final_grade, format);

  if (format === "pass_fail" && !value) {
    if (row?.exam_status === "PASSED" || row?.exam_status === "FAILED") {
      value = row.exam_status;
    } else if (row?.is_passed === true) {
      value = "PASSED";
    } else if (row?.is_passed === false) {
      value = "FAILED";
    }
  }

  return { format, value };
}



export function gradePillClass(value, mode = "scale_5") {

  const gradingMode = normalizeGradingMode(mode);



  if (gradingMode === "pass_fail") {

    const num = Number(value);

    if (Number.isNaN(num)) {

      return "ag-pill ag-pill--neutral";

    }

    return isPassFailPassed(num) ? "ag-pill ag-pill--good" : "ag-pill ag-pill--bad";

  }



  if (gradingMode === "percent") {

    const num = Number(value);

    if (Number.isNaN(num)) {

      return "ag-pill ag-pill--neutral";

    }

    if (num >= 90) {

      return "ag-pill ag-pill--good";

    }

    if (num >= 60) {

      return "ag-pill ag-pill--warn";

    }

    return "ag-pill ag-pill--bad";

  }



  const text = String(value ?? "").toUpperCase();

  if (text === "NP") {

    return "ag-pill ag-pill--bad";

  }

  if (text === "ZW") {

    return "ag-pill ag-pill--neutral";

  }

  const n = Number(value);

  if (Number.isNaN(n)) {

    return "ag-pill ag-pill--neutral";

  }

  if (n >= 4.5) {

    return "ag-pill ag-pill--good";

  }

  if (n >= 3.5) {

    return "ag-pill ag-pill--warn";

  }

  return "ag-pill ag-pill--bad";

}



export function isNumericGradeValue(value, mode = "scale_5") {

  const gradingMode = normalizeGradingMode(mode);

  if (gradingMode !== "scale_5" && gradingMode !== "percent") {

    return false;

  }

  const text = String(value ?? "").trim().toUpperCase();

  if (!text || text === "NP" || text === "ZW") {

    return false;

  }

  const n = Number(text.replace(",", "."));

  return !Number.isNaN(n);

}


